import React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import ArticleIcon from '@mui/icons-material/Article';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import UploadIcon from '@mui/icons-material/Upload';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../hooks/useSnackbar';
import { handleHttpError, isFileBig } from '../utils';
import { useQuery } from '../hooks/useQuery';
import { useParams } from 'react-router-dom';

const CancelarPagamentoDireto = () => {
  const [file, setFile] = React.useState(null);
  const [isCanceling, setIsCanceling] = React.useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const snackbar = useSnackbar();
  const inputFile = React.useRef(null);
  const { pagamentoId } = useParams();
  const { cancelarPagamentoDireto } = useQuery();
  const [justificativa, setJustificativa] = React.useState(null);

  const onChangeFile = (event) => {
    const files = [...event.target.files];

    if (files.length > 0) {
      const file = files[0];
      const { type } = file;
      if (type !== 'application/pdf') {
        snackbar.showSnackbar('Tipo de arquivo inválido. Somente PDF');
        setFile(null);
        inputFile.current.value = '';
        return;
      }

      if (isFileBig(file.size)) {
        snackbar.showSnackbar('Tamanho de arquivo inválido. Máximo é 10MB');
        inputFile.current.value = '';
        return;
      }

      setFile(file);
    }
  };

  const onClickConfirmCancel = async () => {
    try {
      const confirm = await window.confirm(
        'Deseja realmente cancelar esse pagamento?',
      );

      if (!confirm) return;

      setIsCanceling(true);

      const formData = new FormData();
      // formData.append("arquivo", file);
      formData.append('justificativa', justificativa);

      await cancelarPagamentoDireto(pagamentoId, formData);
      navigate(-1);
    } catch (error) {
      console.log('Cancelamento: ', error);
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      setIsCanceling(false);
    }
  };

  return (
    <Box
      mt={8}
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 'calc(100vh - 140px)',
      }}
      backgroundColor="#FAFCFF"
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <IconButton onClick={() => navigate(-1)}>
                <ArrowBackIcon
                  sx={{
                    fontSize: 30,
                    display: { xs: 'none', md: 'flex' },
                    color: '#fff',
                  }}
                />
              </IconButton>

              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                  mr: 1,
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>Cancelar</span>
            </Grid>

            <span style={{ color: 'white', fontSize: 16 }}></span>
          </Grid>
        </Grid>
      </AppBar>

      <Grid item sm={9} paddingLeft="1rem" paddingRight="1rem" marginTop="2rem">
        <Card
          variant="outlined"
          style={{
            borderTop: `8px solid ${theme.palette.primary.main}`,
          }}
        >
          <CardContent>
            {/* <Typography variant="h6" color="primary">
              Importar PDF da Nota Fiscal
            </Typography>

            <Grid container spacing={2} marginTop="1rem">
              <Grid item sm={10}>
                <TextField
                  disabled
                  style={{ width: "100%" }}
                  id="outlined-basic"
                  value={(file && file.name) || ""}
                  placeholder="Importar arquivo PDF"
                  variant="outlined"
                />
              </Grid>
              <Grid item sm={2}>
                <Button
                  style={{ width: "100%", height: 40 }}
                  variant="outlined"
                  component="label"
                  disabled={isCanceling}
                >
                  <UploadIcon />
                  Importar
                  <input
                    onChange={onChangeFile}
                    hidden
                    accept="application/pdf"
                    type="file"
                  />
                </Button>
              </Grid>
            </Grid> */}
            <Grid item sm={12}>
              <Typography variant="h6" color="primary">
                Escreva uma justificativa para cancelar o pagamento
              </Typography>

              <TextField
                margin="normal"
                value={justificativa}
                onChange={(event) => {
                  setJustificativa(event.target.value);
                }}
                multiline
                rows={4}
                fullWidth
                placeholder="Escreva sua justificativa"
              />
            </Grid>
            <Grid container spacing={2} marginTop="4rem">
              <Grid item sm={6}>
                <Button
                  size="large"
                  variant="contained"
                  style={{ width: '100%' }}
                  onClick={() => navigate(-1)}
                >
                  Voltar
                </Button>
              </Grid>
              <Grid item sm={6}>
                <Button
                  size="large"
                  variant="contained"
                  style={{ width: '100%' }}
                  disabled={
                    isCanceling || justificativa == null || justificativa == ''
                  }
                  onClick={onClickConfirmCancel}
                >
                  Confirmar
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Box>
  );
};

export default CancelarPagamentoDireto;
